// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"85f39b2d","420":"cb6a9220","455":"54c4e9d0","821":"989e3a13","977":"6c1c0126"}[chunkId] + ".chunk.js";
};